module.exports = __webpack_public_path__ + "img/alwayslogo.0169be00.png";